import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-269">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-sand border-l-4 border-l-forest bg-white p-4 pr-10 shadow-lift" aria-live="polite" data-id="element-270">
          <button onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted hover:text-forest-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Cerrar aviso" data-id="element-271">
            <XIcon className="h-4 w-4" data-id="element-272" />
          </button>
          <div className="flex gap-3" data-id="element-273">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest" data-id="element-274" />
            <div data-id="element-275">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-forest" data-id="element-276">
                Acceso confirmado
              </p>
              <p className="mt-1 text-sm leading-snug text-forest-dark" data-id="element-277">
                <strong data-id="element-278">Un docente de Neuquén</strong> eligió el
                <br data-id="element-279" />
                <span className="font-bold text-gold-dark" data-id="element-280">
                  Megapack Petróleo y Gas Premium
                </span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-281">Hace unos minutos</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}